import * as React from 'react';
import { RouteComponentProps, Redirect  } from 'react-router';
import { Link} from 'react-router-dom';




export class Home extends React.Component<RouteComponentProps<{}>, {}> {


    renderRedirectIfSession() {
    }

    public render() {
        //let tradeSession = this.state.user.identityState.isTrader;

        //<p>Приветственный дисклэймер:</p>
        //    <ul>
        //        <li><a href='https://get.some.otc/'>OTC 1</a> и <a href='https://google.com'>REPO</a> для работы</li>
        //        <li><a href='http://bbc.com/'>BBC</a> для поиска новостей</li>
        //    </ul>
        //    <p>Для получения доступа в систему необходимо:</p>
        //    <ul>
        //        <li><strong>Заполнить заявку</strong> Например, <em>по email </em> </li>
        //        <li><strong>Сменить пароль</strong> в целях безопасности</li>
        //    </ul>
        //    <h4>Далее</h4>
        //    <p>
        //        См. инструкции
        //    </p>



        return <div>
            <h3 className="rep_authTitle">OTC REPO - Кредиты под залог ценных бумаг</h3>

            <h4 className="rep_authTitle rep_dimmedText">на срок в один день и в 3 месяца</h4>

            <h4 className="rep_authTitle"><Link to={'/login'}>Начать работу</Link></h4>
        </div>;
    }
}
